<template>
  <div class="metric-item">
    <div class="metric-header">
      <span class="metric-name">{{ name }}</span>
      <el-tooltip v-if="description" :content="description" placement="top" effect="light">
        <i class="el-icon-question metric-icon"></i>
      </el-tooltip>
    </div>
    <div class="metric-value">{{ displayValue }}</div>
  </div>
</template>

<script>
export default {
  name: 'MetricCard',
  props: {
    value: {
      type: [Number, String],
      required: true,
      default: 0
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    formatter: {
      type: Function,
      default: null
    }
  },
  computed: {
    displayValue() {
      if (this.formatter) {
        return this.formatter(this.value)
      }
      // 修改判断条件，允许0值正常显示
      return this.value !== null && this.value !== undefined && this.value !== '' ? `${this.value}${this.unit}` : '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.metric-item {
  flex: 0 0 calc(33.333% - 11px);
  max-width: calc(33.333% - 11px);
  min-height: 80px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .metric-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .metric-name {
      font-size: 14px;
      color: #666;
      line-height: 20px;
    }

    .metric-icon {
      margin-left: 4px;
      font-size: 16px;
      color: #999;
      cursor: pointer;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .metric-value {
    font-size: 28px;
    font-weight: bold;
    color: #333;
    line-height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dataBoard/components/MetricCard.vue